import React from 'react';

import UsersList from '../../../Common/UsersList/UsersList';

import './AllUsersList.css';

function AllUsersList() {
  return (
    <div className='Ext-AllUsersList'>
      <UsersList />
    </div>
  );
}

export default AllUsersList;
